import React, { useEffect, useState } from 'react'
import BookInfo from './book-info'
import type { BookProps } from './Book.types'
import BookInfoMobile from './book-info/BookInfoMobile'
import BookInfoDesktop from './book-info/BookInfoDesktop'
import { Cover } from '@arvoreeducacao/bonsai-ds'
import FocusableCover from 'components/modular/focusable-cover'
import {
  LoanBadge,
  isClosedLoan,
  useLoanBadgeLabel
} from 'components/ui/loan-badge'
import { cn } from 'utils/cn'
import useA11yEnabled from 'utils/hooks/use-a11y-enabled'

const Book: React.FC<BookProps> = ({
  id,
  format,
  size,
  slug,
  title,
  author,
  degreesRange,
  imageUrlThumb,
  showInfo,
  additionalActions,
  hasAudioBook,
  percentage,
  language,
  premiumLock,
  moreActionsEvent,
  onClickBook,
  contentType,
  loanActionInfo
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const [isOpenMobile, setIsOpenMobile] = useState(false)
  const { a11yEnabled } = useA11yEnabled()

  const loanStatus = loanActionInfo?.loanStatus
  const loanLabel = useLoanBadgeLabel(loanStatus, loanActionInfo?.dueAt)

  useEffect(() => {
    setIsOpen(false)
    setIsOpenMobile(false)
  }, [slug])

  const mobileContent = (
    <BookInfo
      isOpen={isOpenMobile}
      setIsOpen={setIsOpenMobile}
      title={title}
      author={author}
      format={format}
      slug={slug}
      imageUrlThumb={imageUrlThumb}
      additionalActions={additionalActions}
      contentType={contentType}
      loanActionInfo={loanActionInfo}
    >
      <BookInfoMobile
        setIsOpen={setIsOpenMobile}
        moreActionsEvent={moreActionsEvent}
      />
    </BookInfo>
  )

  return (
    <FocusableCover
      className={cn(isClosedLoan(loanStatus) && '[&_img]:opacity-50')}
      onClickBook={onClickBook}
      title={loanLabel && title ? `${title}, ${loanLabel}` : title}
      a11yEnabled={a11yEnabled}
    >
      <LoanBadge dueAt={loanActionInfo?.dueAt} status={loanStatus} />
      <Cover
        id={id}
        title={title}
        format={format}
        size={size}
        showInfo={showInfo}
        hasAudioBook={hasAudioBook}
        onClickBook={onClickBook}
        percentage={percentage}
        premiumLock={premiumLock}
        coverThumb={imageUrlThumb}
        mobileContent={mobileContent}
      >
        <BookInfo
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          title={title}
          author={author}
          format={format}
          slug={slug}
          language={language}
          imageUrlThumb={imageUrlThumb}
          additionalActions={additionalActions}
          contentType={contentType}
          loanActionInfo={loanActionInfo}
        >
          <BookInfoDesktop
            moreActionsEvent={moreActionsEvent}
            setIsOpen={setIsOpen}
            title={title}
            author={author}
            degreesRange={degreesRange}
            contentType={contentType}
          />
        </BookInfo>
      </Cover>
    </FocusableCover>
  )
}

export default Book
